<div class="z-10 flex flex-col items-center justify-center p-20 m-auto lg:gap-y-40 gap-y-20 w-460">
    <div class="w-auto">
      @for (banner of notificationBanners; track banner) {       
       @if (banner.Show) {
          <app-message-notification panelType="alert" [showPanelIcon]=true class="hidden sm:flex justify-center">     
           The Alphastar portal will undergo maintenance on Saturday, May 30th beginning at 8:00 AM and will be unavailable. Services are expected to be restored by approximately 2:00 PM. We apologize for any inconvenience.
          </app-message-notification>
       }       
      }                        
  </div>
  <img class="w-auto h-48 lg:h-72" src="assets/images/logos/alphastar-full%20logo-mint.png">
  <form [formGroup]="loginForm" class="flex flex-col w-full gap-y-20" (submit)="onLoginSubmit()">
    <div class="flex flex-col flex-shrink-0">
      <label class="mb-5 label" for="userNameOrEmail">Username or Email</label>
      <input type="text" name="userNameOrEmail" formControlName="userNameOrEmail" autofocus class="input is-lg">
    </div>
    <div class="flex flex-col flex-shrink-0">
      <label class="mb-5 label" for="password">Password</label>
      <input type="password" name="password" formControlName="password" class="input is-lg">
    </div>
    <div class="flex flex-col flex-none mt-20 gap-y-20">
      <button class="text-base justify-center button is-lg is-mint focus:ring-0" mat-button type="submit">Sign In</button>
      <!-- <a href="#" class="block my-20 text-base text-center underline mx-30">Need help signing in?</a> -->
    </div>
    <!-- <div *ngIf="locked" class="mx-48 mb-10 font-normal text-center text-md text-red"> TODO: once server side implements lockout policy
    This account has been locked due to too many failed login attempts. It will be unlocked at {{lockedUntil | date}}.
  </div> -->
  @if (disabled) {
    <div class="font-normal text-center text-red">
      Access Denied: Please verify your account information with your ACM team.
    </div>
  }
  @if (invalidCredentials) {
    <div class="font-normal text-center text-md text-red">
      Please verify that you have entered the correct credentials.
    </div>
  }
  <div>
    <a [routerLink]="['/password-reset-request']"><p class="font-normal text-center cursor-pointer text-md text-mint-darker">Need help signing in?</p> </a>
  </div>
</form>
<app-copyright></app-copyright>
</div>